<dx-data-grid
  #dataGrid
  [dataSource]="filteredArticleAssociations"
  [showBorders]="true"
  [columnAutoWidth]="true"
  [rowAlternationEnabled]="true"
  [height]="'100%'"
  (onRowInserting)="onRowInserting($event)"
  (onRowUpdating)="onRowUpdating($event)"
  (onInitNewRow)="onInitNewRow($event)"
  (onEditorPreparing)="onEditorPreparing($event)"
  (onEditingStart)="onEditingStart($event)">

  <dxo-toolbar>
    <dxi-item
      location="before"
      locateInMenu="never"
      template="tabsTemplate">
    </dxi-item>
    <dxi-item
      widget="dxButton"
      location="after"
      [options]="{
        icon: 'add',
        onClick: onAddingClick
      }">
    </dxi-item>
    <dxi-item
      widget="dxButton"
      location="after"
      [options]="{
        icon: 'refresh',
        hint: 'Rafraîchir les données',
        onClick: refreshDataGrid
      }">
    </dxi-item>
    <!-- Template pour les onglets de type association -->
    <div *dxTemplate="let data of 'tabsTemplate'">
      <div class="toolbar-tabs">
        <dx-tabs
          [dataSource]="tabsDataSource"
          [selectedIndex]="selectedTabIndex"
          (onItemClick)="onTabClick($event)">
          <div *dxTemplate="let tab of 'item'" class="tab-item">
            {{ tab.text }}
          </div>
        </dx-tabs>
      </div>
    </div>
  </dxo-toolbar>

  <!-- On affiche pas l'article parent, car on l'utilisateur le connais déjà (cette vue est sur la fiche article-detail) -->
  <dxi-column dataField="id" caption="ID" [visible]="false">
  </dxi-column>
  <dxi-column dataField="articleId" caption="ID Article" [visible]="false">
  </dxi-column>
  <dxi-column dataField="articleAssocieId" caption="ID Article Associé" [visible]="false">
  </dxi-column>
  <dxi-column dataField="articleLibelle" caption="Article" [visible]="false"></dxi-column>

  <dxi-column dataField="associationType" caption="Type" [width]="180">
    <dxo-lookup
      [dataSource]="associationTypes"
      valueExpr="id"
      displayExpr="text">
    </dxo-lookup>
  </dxi-column>
  <dxi-column dataField="articleAssocieLibelle" caption="Article Associé"></dxi-column>
  <dxi-column dataField="quantite" caption="Quantité"></dxi-column>

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[5, 10, 20]"
    [showInfo]="true">
  </dxo-pager>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-search-panel [visible]="true" placeholder="Rechercher..."></dxo-search-panel>
  <dxo-editing
    mode="popup"
    [allowUpdating]="true"
    [allowAdding]="true"
    [allowDeleting]="true">
    <dxo-popup
      title="Association d'articles"
      [showTitle]="true"
      [width]="700"
      [height]="350">
    </dxo-popup>

    <dxo-form>
        <dxi-item
          dataField="articleId"
          [label]="{text: 'Article Principal'}"
          [colSpan]="2"
          editorType="dxSelectBox"
          [editorOptions]="{
            dataSource: articleDataSource,
            searchEnabled: true,
            displayExpr: articleDisplayExpr,
            valueExpr: 'id',
            showClearButton: true,
            searchExpr: ['libelleLong', 'codeBo'],
            showDataBeforeSearch: true,
            value: articleId,
            readonly: !!articleId,
            disabled: !!articleId
          }"
        ></dxi-item>
        <dxi-item
          dataField="articleAssocieId"
          [label]="{text: 'Article Associé'}"
          [colSpan]="2"
          editorType="dxSelectBox"
          [editorOptions]="{
            dataSource: articleDataSource,
            searchEnabled: true,
            displayExpr: articleDisplayExpr,
            valueExpr: 'id',
            showClearButton: true,
            searchExpr: ['libelleLong', 'codeBo'],
            showDataBeforeSearch: true,
          }"
        ></dxi-item>
        <dxi-item dataField="associationType" editorType="dxSelectBox" [isRequired]="true"></dxi-item>
        <dxi-item
          dataField="quantite"
          [isRequired]="true"
          [editorOptions]="{
            value: 1,
            min: 1
          }">
          <dxi-validation-rule type="numeric"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="1" message="La quantité doit être d'au moins 1"></dxi-validation-rule>
        </dxi-item>
    </dxo-form>
  </dxo-editing>

  <dxi-column type="buttons" [width]="110">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete" [onClick]="onDeleteClick"></dxi-button>
  </dxi-column>
</dx-data-grid>